"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var indicator_service_1 = require("./indicator.service");
var indicator_view_model_1 = require("./model/indicator/indicator-view.model");
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var path_helper_1 = require("./config/path.helper");
var category_convert_util_1 = require("./util/category-convert.util");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var http_1 = require("@angular/common/http");
var from_1 = require("rxjs/observable/from");
var operators_1 = require("rxjs/operators");
/**
 * @author gevorg.avetisyan on 4/27/2018.
 */
var HttpIndicatorService = /** @class */ (function (_super) {
    __extends(HttpIndicatorService, _super);
    function HttpIndicatorService(http, applicationPropertiesService, sessionDataProvider, authorizationService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.applicationPropertiesService = applicationPropertiesService;
        _this.sessionDataProvider = sessionDataProvider;
        _this.authorizationService = authorizationService;
        _this.meServiceUriKey = "me-de-service-url";
        _this.meServiceUri$ = from_1.from(_this.applicationPropertiesService.getProperty(_this.meServiceUriKey));
        return _this;
    }
    HttpIndicatorService.prototype.getIndicators = function () {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.INDICATORS); }));
    };
    HttpIndicatorService.prototype.getIndicatorsByIFSystemNameAndIFItemId = function (systemName, itemId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.INDICATORS + '/' + systemName + "/" + itemId); }), operators_1.map(function (response) {
            return response.map(function (value) {
                return new indicator_view_model_1.IndicatorView(value.id, new idm_crosscutting_concepts_frontend_1.MultilingualString(category_convert_util_1.ConvertUtil.objectToMap(value.name)), value.typeId, value.representId, value.contextId);
            });
        }));
    };
    HttpIndicatorService.prototype.attachIndicators = function (systemName, itemId, indicatorIds) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + path_helper_1.PathHelper.INDICATORS + '/' + systemName + "/" + itemId, indicatorIds);
        }));
    };
    HttpIndicatorService.prototype.attachIndicator = function (systemName, itemId, indicatorId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + path_helper_1.PathHelper.INDICATORS + '/' + systemName + "/" + itemId + "/" + indicatorId, null);
        }));
    };
    HttpIndicatorService.prototype.deleteAttachedIndicators = function (systemName, itemId, indicatorIds) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.put(url + path_helper_1.PathHelper.INDICATORS + '/' + systemName + "/" + itemId, indicatorIds); }));
    };
    HttpIndicatorService.prototype.deleteAttachedIndicator = function (systemName, itemId, indicatorId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.delete(url + path_helper_1.PathHelper.INDICATORS + '/' + systemName + "/" + itemId + "/" + indicatorId); }));
    };
    HttpIndicatorService.prototype.getIndicator = function (indicatorId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.INDICATORS + '/' + indicatorId); }));
    };
    HttpIndicatorService.prototype.deleteIndicator = function (indicatorId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.delete(url + path_helper_1.PathHelper.INDICATORS + '/' + indicatorId); }));
    };
    HttpIndicatorService.prototype.insertIndicator = function (indicator) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + path_helper_1.PathHelper.INDICATORS, indicator);
        }), operators_1.map(function (response) {
            return category_convert_util_1.ConvertUtil.backendSaveResultToFrontendSaveResult(response);
        }));
    };
    HttpIndicatorService.prototype.copyIndicator = function (indicatorId, params) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.post(url + path_helper_1.PathHelper.INDICATORS + '/' + indicatorId, params || {}); }), operators_1.map(function (response) { return category_convert_util_1.ConvertUtil.backendCopyResultToFrontendCopyResult(response); }));
    };
    HttpIndicatorService.prototype.updateIndicator = function (indicator) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.put(url + path_helper_1.PathHelper.INDICATORS, indicator); }), operators_1.map(function (response) { return category_convert_util_1.ConvertUtil.backendSaveResultToFrontendSaveResult(response); }));
    };
    HttpIndicatorService.prototype.getIndicatorTemplates = function () {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.INDICATOR_TEMPLATES); }));
    };
    HttpIndicatorService.prototype.getIndicatorTemplate = function (indicatorTemplateId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.INDICATOR_TEMPLATES + indicatorTemplateId); }));
    };
    HttpIndicatorService.prototype.deleteIndicatorTemplate = function (indicatorTemplateId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.delete(url + path_helper_1.PathHelper.INDICATOR_TEMPLATES + indicatorTemplateId); }));
    };
    HttpIndicatorService.prototype.insertIndicatorTemplate = function (indicatorTemplate) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.post(url + path_helper_1.PathHelper.INDICATOR_TEMPLATES, indicatorTemplate); }), operators_1.map(function (response) { return category_convert_util_1.ConvertUtil.backendSaveResultToFrontendSaveResult(response); }));
    };
    HttpIndicatorService.prototype.updateIndicatorTemplate = function (indicatorTemplate) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.put(url + path_helper_1.PathHelper.INDICATOR_TEMPLATES, indicatorTemplate); }), operators_1.map(function (response) { return category_convert_util_1.ConvertUtil.backendSaveResultToFrontendSaveResult(response); }));
    };
    HttpIndicatorService.prototype.getIndicatorTemplateThumbnailPaths = function () {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.INDICATOR_TEMPLATES + 'thumbnails'); }));
    };
    HttpIndicatorService.prototype.getIndicatorDataPoints = function (dataPointId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            var headers = new http_1.HttpHeaders();
            var params = new http_1.HttpParams().append('dataPointId', dataPointId.toString());
            return _this.http.get(url + path_helper_1.PathHelper.INDICATOR_DATA_POINTS, { headers: headers, params: params });
        }));
    };
    HttpIndicatorService.prototype.validate = function (indicator) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.post(url + path_helper_1.PathHelper.VALIDATE, indicator); }), operators_1.map(function (response) { return category_convert_util_1.ConvertUtil.ConvertToValidationMessageModel(response); }));
    };
    HttpIndicatorService.prototype.getPermissions = function (category, permissionType, wfStateId) {
        var _this = this;
        return this.sessionDataProvider.getCurrentUserData().pipe(operators_1.mergeMap(function (userData) {
            var categoryPermissionRequestDataDto = {
                userId: userData.userId,
                categorySystemNames: [category],
                workflowStateId: wfStateId,
                permissionType: permissionType,
                conditionalPermissionValues: null
            };
            return _this.authorizationService.getCategoryPermissionsValues(categoryPermissionRequestDataDto);
        }), operators_1.map(function (permissionsMap) { return Array.from(permissionsMap.get(category))[0].access == idm_authorization_client_js_1.Access.FULL; }));
    };
    HttpIndicatorService.prototype.canDeleteIndicator = function (indicatorId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.options(url + path_helper_1.PathHelper.INDICATORS + '/' + indicatorId); }));
    };
    HttpIndicatorService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper, idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_session_data_provider_api_js_1.SessionDataProvider, idm_authorization_client_js_1.AuthorizationService])
    ], HttpIndicatorService);
    return HttpIndicatorService;
}(indicator_service_1.IndicatorService));
exports.HttpIndicatorService = HttpIndicatorService;
//# sourceMappingURL=http-indicator.service.js.map